import { render } from "./buttonOnOff.vue?vue&type=template&id=0647c744&scoped=true"
import script from "./buttonOnOff.vue?vue&type=script&lang=js"
export * from "./buttonOnOff.vue?vue&type=script&lang=js"

import "./buttonOnOff.vue?vue&type=style&index=0&id=0647c744&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0647c744"]])

export default __exports__